module.exports = __webpack_public_path__ + "static/media/apple_white.a14d6e62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Badges/medias/apple_white.svg
// module id = 157
// module chunks = 0